// src/hooks/useNotifications.js
import { useState, useEffect } from 'react';
import notificationService from '../services/notificationService';

export const useNotifications = () => {
  const [isSupported, setIsSupported] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [fcmToken, setFcmToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    initializeNotifications();
  }, []);

  const initializeNotifications = async () => {
    setIsLoading(true);
    
    try {
      // Check if notifications are supported
      if (!('Notification' in window)) {
        setIsSupported(false);
        setIsLoading(false);
        return;
      }

      setIsSupported(true);

      // Initialize notification service
      const initialized = await notificationService.initialize();
      
      if (initialized) {
        setIsEnabled(notificationService.isNotificationEnabled());
        setFcmToken(notificationService.getCurrentToken());
      }
    } catch (error) {
      console.error('Error initializing notifications:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const requestPermission = async () => {
    try {
      const initialized = await notificationService.initialize();
      
      if (initialized) {
        setIsEnabled(notificationService.isNotificationEnabled());
        setFcmToken(notificationService.getCurrentToken());
        return true;
      }
      
      return false;
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      return false;
    }
  };

  const refreshToken = async () => {
    try {
      await notificationService.refreshToken();
      setFcmToken(notificationService.getCurrentToken());
    } catch (error) {
      console.error('Error refreshing token:', error);
    }
  };

  return {
    isSupported,
    isEnabled,
    fcmToken,
    isLoading,
    requestPermission,
    refreshToken,
    showNotification: notificationService.showNotification.bind(notificationService)
  };
};
